var render = function render(){var _vm=this,_c=_vm._self._c;return _c('join-page')
}
var staticRenderFns = []

export { render, staticRenderFns }